import React from 'react';

import {
  Container,
  Text,
} from '@uncinc/uncinc-react-kitchen-sink';
import { DynamicMediaItem } from '@uncinc/react-drupal-core';
import type { ImmutableEntity } from '@uncinc/react-drupal-core/types';

import { ButtonWrapper } from '../../../components';
import type { ParagraphImageTicker as Type } from '../../../types/uncinc_profile/paragraphs';

import './style.scss';

interface ParagraphImageTickerProps {
  id?: string;
  entity: ImmutableEntity<Type>;
}

const ParagraphImageTicker: React.FC<ParagraphImageTickerProps> = ({
  id,
  entity,
}) => {
  const paragraphImageTicker = entity.toJS();

  const title = paragraphImageTicker.field_title[0]?.value;
  const body = paragraphImageTicker.field_body[0]?.processed || '';
  const images = paragraphImageTicker.field_images;
  const half = Math.ceil(images.length / 2);

  const tickerTapeOne = images.slice(0, half);
  const tickerTapeTwo = images.slice(half);

  const link = paragraphImageTicker.field_link[0];
  const linkTitle = link?.title;
  const linkUrl = link?.alias || link?.uri;
  const secondaryLink = paragraphImageTicker.field_link_secondary[0];
  const secondaryLinkTitle = secondaryLink?.title;
  const secondaryLinkUrl = secondaryLink?.alias || secondaryLink?.uri;

  const animationDuration = images.length < 16 ? '45s' : '90s';
  const tapeRepeatCount = images.length < 12 ? 3 : 2;

  return (
    <div id={id} className="Paragraph ParagraphImageTicker">
      <Container>
        <div className="row">
          <div className="col-12 col-md-10 col-lg-6 offset-lg-1 col-xl-5 offset-xl-1">
            <div className="ParagraphImageTicker__body">
              <Text
                title={title}
                text={body}
              />

              {(linkUrl || secondaryLinkUrl) && (
                <div className="ParagraphImageTicker__links">
                  {linkUrl && (
                    <ButtonWrapper
                      type="secondary"
                      href={linkUrl}
                    >
                      {linkTitle}
                    </ButtonWrapper>
                  )}

                  {secondaryLinkUrl && (
                    <ButtonWrapper
                      type="textual"
                      inverted
                      href={secondaryLinkUrl}
                    >
                      {secondaryLinkTitle}
                    </ButtonWrapper>
                  )}
                </div>
              )}
            </div>
          </div>
          <div className="col-full col-lg-5 col-xl-6">
            <div className="ParagraphImageTicker__outer-wrapper">
              <div className="ParagraphImageTicker__ticker-wrapper ParagraphImageTicker__ticker-wrapper__one">
                {[...Array(tapeRepeatCount)].map(() => (
                  <div
                    className="ParagraphImageTicker__ticker-tape ParagraphImageTicker__ticker-tape__one"
                    style={{ animationDuration }}
                  >
                    {tickerTapeOne.map((image) => (
                      <div className="ParagraphImageTicker__image-wrapper">
                        <DynamicMediaItem
                          media={image}
                          imageAspectRatio="original"
                        />
                      </div>
                    ))}
                  </div>
                ))}
              </div>
              <div className="ParagraphImageTicker__ticker-wrapper ParagraphImageTicker__ticker-wrapper__two">
                {[...Array(tapeRepeatCount)].map(() => (
                  <div
                    className="ParagraphImageTicker__ticker-tape ParagraphImageTicker__ticker-tape__two"
                    style={{ animationDuration }}
                  >
                    {tickerTapeTwo.map((image) => (
                      <div className="ParagraphImageTicker__image-wrapper">
                        <DynamicMediaItem
                          media={image}
                          imageAspectRatio="original"
                        />
                      </div>
                    ))}
                  </div>
                ))}
              </div>
              <div className="ParagraphImageTicker__overlay" />
            </div>
          </div>

        </div>

      </Container>
    </div>
  );
};

export default ParagraphImageTicker;
